import { UserInfo } from './AdobeAnalytics/types';
import { customParseJwt, getTokensFromCookies } from '../hooks/useAuth/utils';
import { logError } from './log';

export const getUserInfoFromTokens = (): UserInfo => {
  const { viaxToken, almToken /* idToken */ } = getTokensFromCookies();
  const info = {
    adminType: '',
    almId: '',
    connectId: '',
  };

  if (!viaxToken && !almToken /* && !idToken */) {
    logError('getUserInfoFromTokens: No tokens found in cookies');
    return info;
  }

  try {
    const ecomInfo = customParseJwt<{
      aud: string;
      realm_access: { roles: string[] };
      sub: string;
      exp: number;
    }>(viaxToken);

    if (ecomInfo?.exp) {
      info.adminType = ecomInfo.realm_access?.roles?.includes('admin')
        ? 'admin'
        : 'not-admin';
    }

    const almInfo = customParseJwt<{
      alm_guid: string;
      exp: number;
    }>(almToken);

    if (typeof almInfo?.alm_guid === 'string') {
      info.almId = almInfo.alm_guid;
    }

    // TODO: Add connectId when spectrabase is ready
    // const idInfo = customParseJwt<{
    //   sub: string;
    //   ids: { alm: string }[];
    //   exp: number;
    // }>(idToken);

    // if (idInfo?.sub) {
    //   info.connectId = idInfo.sub || '';
    // }

    // if (!info.almId && idInfo.ids?.[0]?.alm) {
    //   info.almId = idInfo.ids[0].alm;
    // }

    return info;
  } catch (error) {
    logError('getUserInfoFromTokens: Failed to parse tokens:', error);
    return info;
  }
};
